module.exports = __webpack_public_path__ + "img/new.f9fd88d8.png";